import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TableCell from '@material-ui/core/TableCell';

class BodyCell extends React.Component {
  static propTypes = {
    column: PropTypes.shape({}).isRequired,
    editing: PropTypes.bool.isRequired,
    index: PropTypes.number.isRequired,
    value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    fvalue: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    object: PropTypes.shape({}).isRequired,
    error: PropTypes.string,
    tableHandler: PropTypes.shape({
      onEditCell: PropTypes.func,
    }).isRequired,
    leaf: PropTypes.bool,
    collapsed: PropTypes.bool,
  }

  static defaultProps = {
    value: undefined,
    error: '',
    fvalue: undefined,
    leaf: false,
    collapsed: false,
  }

  constructor(props) {
    super(props);

    this.handleCellEdit = this.handleCellEdit.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if ((nextProps.editing !== this.props.editing)
          || (nextProps.value !== this.props.value)
          || (nextProps.fvalue !== this.props.fvalue)
          || (nextProps.leaf !== this.props.leaf)
          || (nextProps.collapsed !== this.props.collapsed)) {
      return true;
    }
    const { editing, column = {} } = this.props;
    const CellCmp = editing && column.editorCmp || column.rendererCmp;
    if (CellCmp) {
      if (editing || !column.valueOnly) {
        return true;
      }
      if (column.renderProps && column.renderProps.find(p => nextProps[p] !== this.props[p])) {
        return true;
      }
    }
    return false;
  }

  handleCellEdit(e) {
    const { column = {}, index, tableHandler } = this.props;
    tableHandler.onEditCell(e, column, index);
  }

  render() {
    const { column = {}, error, editing, object, value, fvalue } = this.props;
    const CellCmp = editing && column.editorCmp || column.rendererCmp;
    return (
      <TableCell
        align={column.align}
        padding={column.padding}
        className={classNames(editing ? 'tuc-table-cell-editing' : '', column.numeric ? 'tuc-table-cell-numeric' : '', column.tree && 'tuc-table-cell-tree', column.className)}
      >
        {CellCmp ? (
          <CellCmp
            {...this.props}
            editing={editing}
            onChange={this.handleCellEdit}
            value={value}
            error={error}
            object={object}
            type={column.type}
            property={column}
          />
        ) : (
          <span>{fvalue}</span>
        )}
      </TableCell>
    );
  }
}

export default BodyCell;
